/** Console prefix for comparing CMS/meta/navigation input vs analytics output (CONTENT-PLAY, etc.). */
export const FE_ANALYTICS_META_LOG_KEY = "[FE-Analytics-Meta]";

/** Non-prod always; prod only when `localStorage.FE_ANALYTICS_META_DEBUG === "1"`. */
export const shouldLogFeAnalyticsMeta = () => {
    if (typeof window === "undefined") return false;
    try {
        if (process.env.NODE_ENV !== "production") return true;
        return window.localStorage?.getItem("FE_ANALYTICS_META_DEBUG") === "1";
    } catch (e) {
        return false;
    }
};

const stableSerialize = (obj) => {
    try {
        return JSON.stringify(obj);
    } catch (e) {
        return `${Date.now()}`;
    }
};

const lastSignatures = Object.create(null);

/**
 * Drops Mixpanel CONTENT-PLAY fields that change every tick (watch time, timestamps, buffers)
 * so debug logs dedupe instead of flooding the console.
 */
export const pickStableContentPlayMixpanelProps = (props = {}) => {
    if (!props || typeof props !== "object") {
        return props;
    }
    const omit = [
        "WATCH-DURATION",
        "WATCH-DURATION-MINUTES",
        "WATCH-DURATION-SECONDS",
        "BUFFER-DURATION-MINUTES",
        "BUFFER-DURATION-SECONDS",
        "START-TIME",
        "STOP-TIME",
        "SEEK-BAR-PROGRESS",
        "NUMBER-OF-PAUSE",
        "NUMBER-OF-RESUME",
        "VIDEO-QUALITY",
        "token",
    ];
    const out = { ...props };
    omit.forEach((k) => {
        delete out[k];
    });
    return out;
};

export const logFeAnalyticsMeta = (context, payload) => {
    if (!shouldLogFeAnalyticsMeta() || typeof console === "undefined" || !console.info) {
        return;
    }
    console.info(FE_ANALYTICS_META_LOG_KEY, context, payload);
};

/**
 * Logs only when `signaturePayload` serialization changes for `dedupeKey`.
 * Always prints `payload` (can include volatile fields).
 */
export const logFeAnalyticsMetaIfChanged = (dedupeKey, context, payload, signaturePayload) => {
    if (!shouldLogFeAnalyticsMeta() || typeof console === "undefined" || !console.info) {
        return;
    }
    const sigSource = signaturePayload !== undefined ? signaturePayload : payload;
    const sig = stableSerialize(sigSource);
    if (lastSignatures[dedupeKey] === sig) {
        return;
    }
    lastSignatures[dedupeKey] = sig;
    console.info(FE_ANALYTICS_META_LOG_KEY, context, payload);
};
